import type React from 'react';
import { useTranslation } from 'react-i18next';
import Loop from '@mui/icons-material/Loop';
import { Button, Typography } from '@mui/material';

import history from 'src/services/routing/history';
import { routePaths } from 'src/services/routing/routePaths';
import { useSection } from 'src/components/app/context/SectionContext';
import { useUserContext } from 'src/components/app/context/UserContext';

import { styles } from './index.styles';

const SurveySwitcher: React.FC = () => {
  const { t } = useTranslation('survey');
  const { user } = useUserContext();
  const { section } = useSection();

  const handleSwitchProject = () => {
    history.push(routePaths.SURVEY_LIST, { fromSection: section });
  };

  return !user ? null : (
    <Button sx={styles.button} onClick={handleSwitchProject} endIcon={<Loop />}>
      <Typography variant="body3" sx={{ fontWeight: 600 }}>
        {t('switchProject')}
      </Typography>
    </Button>
  );
};

export default SurveySwitcher;
